import { Injectable } from '@angular/core';
import { MotifModal, MotifModalRef } from '@ey-xd/ng-motif';

import { ErrorModalData } from 'src/app/utils/interfaces/error-modal.interface';
import { ErrorModalComponent } from 'src/app/shared/tdd/components/error-modal/error-modal.component';

@Injectable({
  providedIn: 'root',
})
export class ErrorModalService {
  private modalRef?: MotifModalRef<ErrorModalComponent>;

  constructor(private readonly motifModal: MotifModal) {}

  show(error: ErrorModalData): void {
    this.modalRef?.close();

    const modalRef = this.motifModal.open(ErrorModalComponent, {
      disableClose: false,
    });

    modalRef.componentInstance.data = error;

    this.modalRef = modalRef;
  }

  close(): void {
    this.modalRef?.close();
    this.modalRef = undefined;
  }
}
